"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _DropdownToggle = require("react-overlays/DropdownToggle");

var _BaseTheme = _interopRequireDefault(require("../Themes/BaseTheme"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Components
const ButtonStyled = _styledComponents.default.button.withConfig({
  displayName: "DropdownToggle__ButtonStyled",
  componentId: "design-system__sc-1jun194-0"
})(["border:none;background:transparent;padding:0 0.5rem;height:4.5rem;line-height:4.5rem;border-bottom:1px solid ", ";border-top:2px solid white;outline:none;&:hover{cursor:pointer;border-top:2px solid ", ";}", ""], _BaseTheme.default.colors.lightgray, _BaseTheme.default.colors.blue, _ref => {
  let {
    isOpen
  } = _ref;
  return isOpen && (0, _styledComponents.css)(["border-top:2px solid ", ";"], _BaseTheme.default.colors.blue);
});

const DropdownToggle = _ref2 => {
  let {
    id,
    children,
    isOpen
  } = _ref2;
  const [props, {
    toggle
  }] = (0, _DropdownToggle.useDropdownToggle)();
  const {
    ref,
    'aria-haspopup': ariaHasPopup,
    'aria-expanded': ariaExpanded
  } = props;
  return /*#__PURE__*/_react.default.createElement(ButtonStyled, {
    isOpen: isOpen,
    type: "button",
    id: id,
    onClick: toggle,
    ref: ref,
    "aria-haspopup": ariaHasPopup,
    "aria-expanded": ariaExpanded
  }, children);
};

DropdownToggle.propTypes = {
  id: _propTypes.default.string,
  isOpen: _propTypes.default.bool,
  children: _propTypes.default.node.isRequired,
  ref: _propTypes.default.func,
  'aria-haspopup': _propTypes.default.bool,
  'aria-expanded': _propTypes.default.bool
};
DropdownToggle.defaultProps = {
  id: undefined,
  isOpen: false,
  ref: undefined,
  'aria-haspopup': undefined,
  'aria-expanded': undefined
};
var _default = DropdownToggle;
exports.default = _default;